export default __webpack_public_path__ + "static/media/element_12.aeb2c818.webp";